import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import { useTranslation } from 'react-i18next';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { testimonialsData } from '../../data/Data';
import { Box, LazyImage } from '../../Styled/Elements';
import { SliderWrapper } from './Styled';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const TestimonialsSlider = ({ onOpenLightbox }) => {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const { i18n } = useTranslation();
    const isRTL = i18n.dir() === 'rtl';

    const handleSlideClick = (swiper) => {
        if (swiper.clickedIndex == null) return;
        const slide = swiper.slides[swiper.clickedIndex];
        const index = slide?.swiperSlideIndex;
        if (index !== undefined) onOpenLightbox(index);
    };

    const initNavigation = (swiper) => {
        if (!prevRef.current || !nextRef.current) return;
        swiper.params.navigation.prevEl = prevRef.current;
        swiper.params.navigation.nextEl = nextRef.current;
        swiper.navigation.destroy();
        swiper.navigation.init();
        swiper.navigation.update();
    };

    return (
        <SliderWrapper className="testimonials-slider">
            <button
                type="button"
                ref={prevRef}
                className="slider-arrow slider-arrow-prev"
                aria-label="Previous testimonial"
            >
                <BsChevronLeft size={22} />
            </button>
            <button
                type="button"
                ref={nextRef}
                className="slider-arrow slider-arrow-next"
                aria-label="Next testimonial"
            >
                <BsChevronRight size={22} />
            </button>

            <Swiper
                key={isRTL ? 'rtl' : 'ltr'}
                dir={isRTL ? 'rtl' : 'ltr'}
                modules={[Navigation, Pagination]}
                grabCursor
                centeredSlides
                loop
                slidesPerView={3}
                spaceBetween={20}
                speed={600}
                slideToClickedSlide
                pagination={{ clickable: true }}
                onSwiper={initNavigation}
                onClick={handleSlideClick}
                breakpoints={{
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 12,
                    },
                    576: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    },
                }}
                className="testimonials-swiper"
            >
                {testimonialsData.map((item, index) => (
                    <SwiperSlide key={index}>
                        <Box
                            className="testimonial-card slider-card"
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    onOpenLightbox(index);
                                }
                            }}
                        >
                            <LazyImage src={item.src} alt={item.alt} />
                        </Box>
                    </SwiperSlide>
                ))}
            </Swiper>
        </SliderWrapper>
    );
};

export default TestimonialsSlider;
